/**
 * ==============================================
 * =========  国际化语言 zh-cn.js ================
 * ====== 厦门科软信息科技有限公司 版权所有 =======
 * ==============================================
 */

const zh = {
    /**
     * =============================================
     * ================ 公共部分 ====================
     * =============================================
     */


    /**
     * 列表操作按钮
     */
    "toolbar": {
        "btnAdd": "新增",
        "btnModify": "修改",
        "btnUpdate": "更新",
        "btnEdit": "编辑",
        "btnDelete": "删除",
        "btnSoftDelete": "设为删除",
        "btnEnable": "启用",
        "btnNoEnable": "禁用",
        "btnResetAppSecret": "重置AppSecret",
        "btnResetEncodingAESKey": "重置消息密钥"
    },
    /**
     * 窗口操作按钮
     */
    "button": {
        "btnOk": "确定",
        "btnSave": "保存",
        "btnCancel": "取消",
        "btnEdit": "编辑",
        "btnClose": "关闭"
    },

    /**
     * 提示消息
     */
    "message": {
        "editAlertTips": "请选择一条数据进行编辑/修改",
        "alertTips1": "请先选择要操作的数据",
        "successTips": "恭喜你，操作成功！",
        "deleteTips": "是否确认删除所选的数据项?",
        "selectDataTips": "请选择一条数据进行重置",
        "copySuccess": '复制成功',
        "validError": '表单数据校验失败'
    },

    /**
     * =============================================
     * ================ 各个模块 ====================
     * =============================================
     */

    "login": {
        "inputAccount": "登录账号",
        "inputPassword": "登录密码",
        "inputVcode": "验证码",
        "btnLoginText": "登 录",
        "btnLoginIngText": "登 录 中...",
        "txtReg": "没有账号？",
        "regLink": "点此注册",
        "txtLogin": "已有账号？",
        "loginLink": "登录已有账号",
        "ruleAccount": "请输入登录账号！",
        "rulePassword": "请输入您的账号密码,且不小于6位！",
        "ruleVcodeTip": "请输入验证码",
        "ruleVcodeLengTip": "长度4字符"
    },
    "dashboard": {
        "serverInfo": "服务器信息",
        "serverName": "服务器名称",
        "operatingSystem": "操作系统",
        "serverIP": "服务器IP",
        "numberofCPUs": "CPU数量"
    },
    /**
     * 默认应用管理
     */
    "app": {
        "systemName": "供应链中台系统",
        "companyName": "厦门科软信息科技有限公司",
        "icpCode": "闽ICP备2021017202号",
        "copyRight": "Copyright © 2021-2025 xmtechsoft.com",
    },
    /**
      * =============================================
      * ================ 页面设计 ====================
      * =============================================
      */
    "shopdesigns": {
        "fields": {
            "imgSlide": '图片轮播',
            "topSlide": '置顶轮播',
            "imgSingle": '单图列表',
            "imgWindow": '图片橱窗',
            "imgTwo": '二图组合',
            "videos": '视频组',

            "search": '搜索框',
            "notice": '公告组',

            "navBar": '导航组',
            "goods": '商品组',
            "goodTabBar": '选项卡',
            "record": '购买记录',

            "space": '辅助空白',
            "text": '文本域',
            "divider": '分割线',
        },
        "medium": {
            "title": '媒体组件',
        },
        "shops": {
            "title": '通用组件',
        },
        "tools": {
            "title": '工具组件',
        }
    },
    "components": {
        "fields": {
            "article": '文章列表',
            "articleClass": '文章分类',

            "group": '团购',
            "seckill": '秒杀',
            "pintuan": '拼团',
            "service": '服务',
            "coupon": '优惠券',

            "module": '模块组',
            "shop": '店铺组',
            "store": '门店组',
            "numBar": '数量组',
            "applet": '小程序',
            "tool": '拓客工具'
        },
        "basic": {
            "title": '基础功能',
        },
        "advance": {
            "title": '活动功能',
        },
        "layout": {
            "title": '特殊功能',
        }
    },
    "description": {
        "containerEmpty": '从左侧拖拽来添加组件',
        "configEmpty": '请添加组件',
    },
    "actions": {
        "clear": '清空',
        "json": '生成JSON',
        "code": '生成代码',
        "reset": '重置',
        "copyData": '复制数据',
        "cancel": '取 消',
        "confirm": '确 定',
    },
    "config": {
        "form": {
            "title": '页面属性',
            "paddingWidth": '页面记录边距宽度',
            "showNavBar": '是否显示顶部导航',
            "showTabBar": '是否显示底部导航'
        },
        "widget": {
            "title": '组件属性',
            "model": '字段标识',
            "name": '组件标题',
            "width": '宽度',
            "height": '高度',
            "duration": '切换时间',
            "size": '大小',
            "labelWidth": '标签宽度',
            "custom": '自定义',
            "placeholder": '占位内容',
            "layout": '布局方式',
            "block": '块级',
            "inline": '行内',
            "contentPosition": '文案位置',
            "left": '左侧',
            "right": '右侧',
            "center": '居中',
            "showInput": '显示输入框',
            "min": '最小值',
            "max": '最大值',
            "step": '步长',
            "multiple": '是否多选',
            "filterable": '是否可搜索',
            "allowHalf": '允许半选',
            "showAlpha": '支持透明度选择',
            "showLabel": '是否显示标签',
            "option": '选项',
            "staticData": '静态数据',
            "remoteData": '远端数据',
            "remoteFunc": '远端方法',
            "value": '值',
            "label": '标签',
            "childrenOption": '子选项',
            "defaultValue": '默认值',
            "showType": '显示类型',
            "isRange": '范围选择',
            "isTimestamp": '是否获取时间戳',
            "startPlaceholder": '开始时间',
            "endPlaceholder": '结束时间',
            "format": '格式',
            "limit": '最大上传数',
            "isQiniu": '使用七牛上传',
            "tokenFunc": '获取七牛Token方法',
            "imageAction": '图片上传地址',
            "tip": '提示说明文字',
            "action": '上传地址',
            "defaultType": '绑定数据类型',
            "string": '字符串',
            "object": '对象',
            "array": '数组',
            "number": '数字',
            "boolean": '布尔值',
            "integer": '整数',
            "float": '浮点数',
            "url": 'URL地址',
            "email": '邮箱地址',
            "hex": '十六进制',
            "gutter": '栅格间隔',
            "columnOption": '列配置项',
            "span": '栅格值',
            "justify": '水平对齐',
            "justifyStart": '左对齐',
            "justifyEnd": '右对齐',
            "justifyCenter": '居中',
            "justifySpaceAround": '两侧间隔相等',
            "justifySpaceBetween": '两端对齐',
            "align": '垂直对齐',
            "alignTop": '顶部对齐',
            "alignMiddle": '居中',
            "alignBottom": '底部对齐',
            "type": '风格类型',
            "default": '默认',
            "card": '选项卡',
            "borderCard": '卡片化',
            "tabPosition": '选项卡位置',
            "top": '顶部',
            "bottom": '底部',
            "tabOption": '标签配置项',
            "tabName": '标签名称',
            "customClass": '自定义Class',
            "attribute": '操作属性',
            "dataBind": '数据绑定',
            "hidden": '隐藏',
            "readonly": '完全只读',
            "disabled": '禁用',
            "editable": '文本框可输入',
            "clearable": '显示清除按钮',
            "arrowControl": '使用箭头进行时间选择',
            "isDelete": '删除',
            "isEdit": '编辑',
            "showPassword": '显示密码',
            "validate": '属性校验',
            "required": '必填',
            "patternPlaceholder": '填写正则表达式',
            "newOption": '新选项',
            "tab": '标签页',
            "validatorRequired": '必须填写',
            "validatorType": '格式不正确',
            "validatorPattern": '格式不匹配',
            "showWordLimit": '显示字数',
            "maxlength": '最大字数',
        }
    },
    "upload": {
        "preview": '预览',
        "edit": '替换',
        "delete": '删除'
    }
}

export default zh